// Module
var code = "<div class=\"scheduling-icons steps-icon\"> <i class=\"fa fa-fw\" title=\"{{item.title|translate}}\" ng-class=\"item.classed\" ng-repeat=\"item in vm.mapped\"></i> </div>";
// Exports
module.exports = code;